import React, { useEffect } from 'react';
import Layout from '~/components/Layout';
import TabListDispatch from '~/components/TabListDispatch';
import { useLang } from '~/hooks/useLang';

export default function ListDispatch() {
  const { translate } = useLang();

  useEffect(() => {
    document.title = translate('Dispatch List - Dispatch System')
  }, [])
  return (
    <Layout
      marginLayout={false}
      sidebar={false}
    >
      <TabListDispatch isNoPaginationWindow={true}/>
    </Layout>
  );
}